<!-- 菜单：系统监控 /pages/dev/monitorManage -->
<template>
  <div class="monitor-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <span>系统监控信息</span>
            <el-button type="primary" size="small" @click="refreshData">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>

          <el-row :gutter="20" v-loading="loading">
            <el-col :span="12">
              <el-card shadow="hover" class="info-card">
                <div slot="header">
                  <i class="el-icon-cpu"></i> 内存信息
                </div>
                <el-descriptions :column="1" border>
                  <el-descriptions-item label="总内存">
                    {{ formatBytes(monitorData.totalMemory) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="已用内存">
                    {{ formatBytes(monitorData.usedMemory) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="空闲内存">
                    {{ formatBytes(monitorData.freeMemory) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="最大可用内存">
                    {{ formatBytes(monitorData.maxMemory) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="内存使用率">
                    <el-progress 
                      :percentage="monitorData.memoryUsagePercent" 
                      :color="getProgressColor(monitorData.memoryUsagePercent)"
                    />
                  </el-descriptions-item>
                </el-descriptions>
              </el-card>
            </el-col>

            <el-col :span="12">
              <el-card shadow="hover" class="info-card">
                <div slot="header">
                  <i class="el-icon-connection"></i> 线程与CPU信息
                </div>
                <el-descriptions :column="1" border>
                  <el-descriptions-item label="可用处理器">
                    {{ monitorData.availableProcessors }} 核
                  </el-descriptions-item>
                  <el-descriptions-item label="当前线程数">
                    {{ monitorData.totalThread }}
                  </el-descriptions-item>
                  <el-descriptions-item label="峰值线程数">
                    {{ monitorData.peakThread }}
                  </el-descriptions-item>
                  <el-descriptions-item label="在线用户数">
                    <el-tag type="success">{{ monitorData.onlineUserCount }}</el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="系统CPU使用率">
                    <el-progress 
                      :percentage="(monitorData.systemCpuUsage * 100).toFixed(1)" 
                      :color="getProgressColor(monitorData.systemCpuUsage * 100)"
                    />
                  </el-descriptions-item>
                  <el-descriptions-item label="JVM CPU使用率">
                    <el-progress 
                      :percentage="(monitorData.jvmCpuUsage * 100).toFixed(1)" 
                      :color="getProgressColor(monitorData.jvmCpuUsage * 100)"
                    />
                  </el-descriptions-item>
                </el-descriptions>
              </el-card>
            </el-col>

            <el-col :span="24" style="margin-top: 20px;">
              <el-card shadow="hover" class="info-card">
                <div slot="header">
                  <i class="el-icon-setting"></i> 系统信息
                </div>
                <el-descriptions :column="2" border>
                  <el-descriptions-item label="系统时间">
                    {{ formatSystemTime(monitorData.systemTime) }}
                  </el-descriptions-item>
                  <el-descriptions-item label="Java版本">
                    {{ monitorData.javaVersion }}
                  </el-descriptions-item>
                  <el-descriptions-item label="操作系统" :span="2">
                    {{ monitorData.osName }}
                  </el-descriptions-item>
                </el-descriptions>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getMonitorInfo } from '@/api/dev/monitorApi'

export default {
  name: 'MonitorManage',
  data() {
    return {
      loading: false,
      monitorData: {
        totalMemory: 0,
        freeMemory: 0,
        usedMemory: 0,
        maxMemory: 0,
        memoryUsagePercent: 0,
        availableProcessors: 0,
        totalThread: 0,
        peakThread: 0,
        onlineUserCount: 0,
        systemTime: '',
        javaVersion: '',
        osName: '',
        systemCpuUsage: 0,
        jvmCpuUsage: 0
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getMonitorInfo()
        if (res && res.data) {
          this.monitorData = res.data
        }
      } catch (error) {
        this.$message.error(error.message || '获取监控信息失败')
      } finally {
        this.loading = false
      }
    },
    refreshData() {
      this.loadData()
    },
    formatBytes(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    getProgressColor(percent) {
      if (percent < 50) return '#67c23a'
      if (percent < 80) return '#e6a23c'
      return '#f56c6c'
    },
    formatSystemTime(timeStr) {
      if (!timeStr || timeStr.length !== 14) return timeStr
      return `${timeStr.slice(0, 4)}-${timeStr.slice(4, 6)}-${timeStr.slice(6, 8)} ${timeStr.slice(8, 10)}:${timeStr.slice(10, 12)}:${timeStr.slice(12, 14)}`
    }
  }
}
</script>

<style scoped>
.monitor-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-card {
  margin-bottom: 0;
}

.el-icon-cpu,
.el-icon-connection,
.el-icon-setting {
  margin-right: 8px;
  color: #409EFF;
}
</style>
